export const sanaBaseUrl = "https://sana.adliran.ir/Sana/Index#/Main";
